export default "__VITE_ASSET__DCvKqNn6__"